var _filter, _marker, _circle, _path, _circle2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "-128 0 256 128",
    refX: 0,
    refY: 64,
    markerUnits: "userSpaceOnUse",
    markerWidth: 256,
    markerHeight: 128,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 64              C 32 64 0 96 -24 112              C 0 112 64 112 90.50966799187808 26.509667991878132              z",
    stroke: "rgba(207, 207, 207, 1)",
    strokeWidth: 10,
    strokeLinejoin: "round",
    fill: "rgba(207, 207, 207, 1)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 224,
    stroke: "rgba(127, 127, 127, 1)",
    strokeWidth: 12,
    fill: "rgba(127, 127, 127, 1)",
    filter: "url(#shadow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 384 256            L 346.5096679918781 165.4903320081219            L 256 128            L 165.4903320081219 165.4903320081219            L 128 256            L 165.4903320081219 346.5096679918781            L 256 384            L 346.5096679918781 346.5096679918781            L 384 256            L 346.5096679918781 165.4903320081219",
    fill: "rgba(207, 207, 207, 1)",
    stroke: "none",
    markerMid: "url(#arrow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 80,
    fill: "rgba(127, 127, 127, 1)",
    stroke: "rgba(127, 127, 127, 1)",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 277 96            C 235 129 176 192 176 256            L 288 184            C 264 184 232 184 216 164            C 236 132 256 108 308 96            C 292 92 284 92 277 96            z",
    fill: "rgba(127, 127, 127, 1)",
    stroke: "rgba(127, 127, 127, 1)",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 280 128            C 288 128 296 127 300 126            C 302 124 304 122 306 118            C 296 118 288 122 280 128            z",
    fill: "rgba(127, 127, 127, 1)",
    stroke: "rgba(127, 127, 127, 1)",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragon);
export default __webpack_public_path__ + "static/media/dragon.728b4582cf9b04d700f1ff11ee0b6e78.svg";
export { ForwardRef as ReactComponent };